import { createContext, useContext } from "react";
const uiKitContext = createContext(null);
const useUiKitTheme = () => {
  const context = useContext(uiKitContext);
  if (!context) {
    throw new Error(
      "useUiKitContext must be defined, please make sure that u are add a context provider"
    );
  }
  return context.theme;
};
export {
  uiKitContext as a,
  useUiKitTheme as u
};
